const SET_PRELOADING_COMPONENT = 'setPreloadingComponent';
const CLEAR_PRELOADING_COMPONENT = 'clearPreloadingComponent';

export { SET_PRELOADING_COMPONENT, CLEAR_PRELOADING_COMPONENT };
